'use client';

import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import AppNav from '@/components/AppNav';
import AdminPanelContent from './components/AdminPanelContent';
import AdminChangePassword from './components/AdminChangePassword';

const SESSION_KEY = 'admin_session';

export default function AdminPanelPage() {
  const router = useRouter();
  const [authenticated, setAuthenticated] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);

  useEffect(() => {
    const session = sessionStorage.getItem(SESSION_KEY);
    if (session !== 'authenticated') {
      router?.replace('/admin-login');
    } else {
      setAuthenticated(true);
    }
  }, [router]);

  function handleLogout() {
    sessionStorage.removeItem(SESSION_KEY);
    router?.replace('/admin-login');
  }

  if (!authenticated) return null;

  return (
    <div className="min-h-screen bg-background">
      <AppNav />
      <main className="pt-20 pb-16 px-6 lg:px-10 2xl:px-16">
        <div className="max-w-screen-2xl mx-auto">
          {/* Admin toolbar */}
          <div className="flex items-center justify-end gap-3 mb-6">
            <button
              onClick={() => setShowChangePassword(true)}
              className="text-sm font-lora text-muted-foreground hover:text-foreground border border-border rounded-lg px-4 py-2 transition hover:bg-card"
            >
              Change Password
            </button>
            <button
              onClick={handleLogout}
              className="text-sm font-lora text-muted-foreground hover:text-foreground border border-border rounded-lg px-4 py-2 transition hover:bg-card"
            >
              Sign Out
            </button>
          </div>

          <AdminPanelContent />
        </div>
      </main>

      {showChangePassword && (
        <AdminChangePassword onClose={() => setShowChangePassword(false)} />
      )}
    </div>
  );
}